import {get, post, del, put} from '@/axios'

export const getList = p => get('/user/list', p);

export const saveAndupdateUser = p => post('/user', p);

export const batchDelete = p => del('/user/batch/' + p);

export const getUser = p => get('/user/' + p);

export const getInfo = p => get('/user/info', p);

export const getRoles = p => get('/user/role/' + p);

export const delUser = p => del('/user/' + p);

export const updatePassword = p => post('/user/updatePassword', p);


// WEBPACK FOOTER //
// ./src/api/user.js